<template>
  <ServiceCard 
    title="API Development"
    subtitle="Scalable API solutions"
    description="Expert API design, implementation, and optimization for your business needs."
    to="/services/api-design"
    gradient-start="#3b82f6"
    gradient-end="#1d4ed8"
    button-text="Learn More"
  />
</template>

<script setup>
import ServiceCard from '~/components/ServiceCard.vue';
</script>